import { render, staticRenderFns } from "./WaitingRoomBrandingEdit.vue?vue&type=template&id=4bad063b&"
import script from "./WaitingRoomBrandingEdit.vue?vue&type=script&lang=ts&"
export * from "./WaitingRoomBrandingEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports